import { z } from 'zod';
/** Machine-readable error returned by every REST endpoint; the UI translates `code`. */
export const ApiError = z.object({
    code: z.string().regex(/^[A-Z][A-Z0-9_]*$/),
    params: z.record(z.string(), z.unknown()).optional(),
    request_id: z.string().optional(),
});
export const HealthStatus = z.enum(['ok', 'degraded', 'down']);
export const HealthCheck = z.object({
    status: HealthStatus,
    latency_ms: z.number().nonnegative().optional(),
    error: z.string().optional(),
});
/** GET /health/ready and GET /health */
export const HealthResponse = z.object({
    status: HealthStatus,
    service: z.string(),
    version: z.string(),
    instance_id: z.string(),
    uptime_s: z.number().nonnegative(),
    checks: z.record(z.string(), HealthCheck),
});
/** GET /api/v1/info — public, unauthenticated metadata used by the web app at bootstrap. */
export const InfoResponse = z.object({
    service: z.string(),
    version: z.string(),
    contracts: z.object({
        api: z.literal('v1'),
        realtime: z.literal('realtime/v1'),
        gateway: z.literal('gateway/v1'),
    }),
});
export * from './admin.js';
export * from './devices.js';
export * from './connections.js';
export * from './alarms.js';
export * from './projects.js';
export * from './groups.js';
export * from './reports.js';
export * from './gis.js';
export * from './inventory.js';
export * from './integrations.js';
export * from './reportProfiles.js';
//# sourceMappingURL=index.js.map